/**
 * Post Editing — service category placeholders.
 * Replace `image` URLs with Honesti Digital project screenshots when available.
 */
export type PostEditingServiceItem = {
    name: string;
    size: "tall" | "wide" | "normal";
    hue: string;
    image: string;
    alt: string;
};

const unsplash = (id: string, alt: string) => ({
    image: `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&h=750&q=80`,
    alt,
});

export const postEditingServices: PostEditingServiceItem[] = [
    {
        name: "Social Media Posts",
        size: "tall",
        hue: "#9e00ff",
        ...unsplash(
            "photo-1611162616305-c69b3fa7fbe0",
            "Social media post creative displayed on a mobile device"
        ),
    },
    {
        name: "Event Posters",
        size: "wide",
        hue: "#002454",
        ...unsplash(
            "photo-1505236858219-8359eb29e329",
            "Event poster and promotional graphics in an urban setting"
        ),
    },
    {
        name: "Product Creatives",
        size: "normal",
        hue: "#1A3D6B",
        ...unsplash(
            "photo-1523275335684-37898b6baf30",
            "Product marketing creative with clean studio photography"
        ),
    },
    {
        name: "Banner Designs",
        size: "normal",
        hue: "#7a00a8",
        ...unsplash(
            "photo-1460925895917-afdab827c52f",
            "Marketing website banner and analytics dashboard screenshot"
        ),
    },
    {
        name: "Carousel Posts",
        size: "tall",
        hue: "#002454",
        ...unsplash(
            "photo-1563986768609-322da13575f3",
            "Carousel-style social media feed on a smartphone screen"
        ),
    },
];
